/*  ========================================================================
    # Components - Project
    ========================================================================  */

import React from 'react';
import PropTypes from 'prop-types';
import bem from '../helpers/bem';
import useTranslation from '../hooks/useTranslation';
import IconNoEntries from '../../images/misc/icon-no-posts.svg';

const NoEntries = text => {
  const __ = useTranslation();

  return (
    <div className={bem('c-no-entries')}>
      <IconNoEntries />
      <div>
        <h4>{__('no-entries-title')}</h4>
        <p dangerouslySetInnerHTML={{ __html: text.text }}></p>
      </div>
    </div>
  );
};

NoEntries.propTypes = {
  text: PropTypes.string
};

export default NoEntries;
